import styled, { css } from 'styled-components';

import { getThemeTransition, media } from '@utils/styled';

import { IS_SCROLLING_DOWN_CLASS } from '@common/constants/body';

export const Container = styled.div`
  position: fixed;
  right: 0;
  ${({ theme }) => theme.getFluidSpacing('bottom', 'widthBased', 0)};
  left: 0;
  z-index: 16;
  display: flex;
  justify-content: space-between;
  max-width: ${({ theme }) => theme.breakpoints[0]}rem;
  margin: 0 auto;
  transition: ${getThemeTransition('transform', 'medium')},
    ${getThemeTransition('margin-bottom', 'medium')};
  transform: translateY(calc(-1 * env(safe-area-inset-bottom)));
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'widthBased', 0)};
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'widthBased', 0)};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 3)};

  ${({ bottomSpacing }) =>
    bottomSpacing &&
    css`
      margin-bottom: ${bottomSpacing};
    `};

  .${IS_SCROLLING_DOWN_CLASS} & {
    transform: translateY(15rem);
  }

  ${({ isSwitcherVisible }) =>
    !isSwitcherVisible &&
    css`
      transform: translateY(15rem);
    `};

  > * {
    flex: 1;
  }

  ${media.from480up`
    ${({ noFilters }) => noFilters && 'padding-top: 0'};
  `}
`;
